import { render } from "./ToggleSlider.vue?vue&type=template&id=6f3b0731&scoped=true"
import script from "./ToggleSlider.vue?vue&type=script&lang=js"
export * from "./ToggleSlider.vue?vue&type=script&lang=js"

import "./ToggleSlider.vue?vue&type=style&index=0&id=6f3b0731&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f3b0731"]])

export default __exports__